import styled from 'styled-components';

import OtherRecipient from './OtherRecipient';
import {NoRecipients, RecipientsTitle} from './styles';
import {OutlookRecipient} from './useOutlookEmailRecipients';

interface Props {
  recipients: OutlookRecipient[];
  agencyId: number;
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
`;

const OtherRecipients = ({recipients, agencyId}: Props) => {
  return (
    <Container>
      <RecipientsTitle>Not in Loxo ({recipients.length})</RecipientsTitle>
      {recipients.length === 0 ? (
        <NoRecipients>None</NoRecipients>
      ) : (
        <>
          {recipients.map((recipient, index) => (
            <OtherRecipient
              key={index}
              recipient={recipient}
              agencyId={agencyId}
            />
          ))}
        </>
      )}
    </Container>
  );
};

export default OtherRecipients;
